/**
 * AI Lesson Video Builder — GA for all orgs: the `lessonVideoBuilder` org flag
 * is no longer read.
 *
 * Kept (name + signature) so the call sites that branch on it keep compiling.
 * It covers the LESSON VIDEO card in the program designer, the Brand Kit card
 * in Organization Settings and the learner video block on the Elliott lesson page.
 */
const useLessonVideoBuilder = (): boolean => true;

export default useLessonVideoBuilder;
